import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import { setAuth, removeAuth } from "../actions";
import { loadCallStatusLabels } from "../utils/callStatusCache";
import API, { clearSession } from "../utils/api";
import Router from "./Router";

class App extends Component {
  state = { ready: false };

  async componentDidMount() {
    // Restore auth state from localStorage, then revalidate against
    // the backend so a session revoked elsewhere doesn't stay trusted locally
    const token = localStorage.getItem("teleAccessToken");
    const userStr = localStorage.getItem("teleUser");
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        this.props.setAuth({ ...user, token });

        const meRes = await API.get("/auth/me");
        const me = meRes.data.data || meRes.data;
        const permissions = me.permissions || [];
        const authUser = {
          id: me.id,
          name: me.name,
          email: me.email,
          role: me.role,
          permissions,
        };
        localStorage.setItem("teleUser", JSON.stringify(authUser));
        localStorage.setItem("telePermissions", JSON.stringify(permissions));
        this.props.setAuth({ ...authUser, token });
      } catch (e) {
        clearSession();
        this.props.removeAuth();
      }
    }
    // Load call status labels globally
    loadCallStatusLabels().catch(() => {
      // Silently fail, labels are optional
    });
    this.setState({ ready: true });
  }

  render() {
    if (!this.state.ready) {
      return null; // Wait for auth state to be restored before rendering routes
    }

    return (
      <BrowserRouter basename="/tele">
        <div>
          <ToastContainer autoClose={3000} />
          <Router />
        </div>
      </BrowserRouter>
    );
  }
}

export default connect(null, { setAuth, removeAuth })(App);
